import { cn } from "../../helpers"
import { body, paragraph } from "../typography"

const accordionItem = (className?: string) =>
  cn(
    [
      "ring-1 ring-neutral-200 rounded-2xl",
      "hover:ring-2 hover:ring-neutral-300 hover:bg-neutral-50 transition-all",
      "focus-within:ring-2 focus-within:ring-blurple-600",
    ],
    className,
  )
const accordionHeader = "flex"
const accordionTrigger = (className?: string) =>
  cn(
    body({ size: "sm" }),
    "flex flex-1 items-center transition-all [&[data-state=open]>svg]:rotate-180 gap-3 px-5 py-4 outline-none",
    className,
  )
const accordionTriggerTextContainer = "flex flex-1 flex-col gap-1 items-start"
const accordionTriggerDescription = cn(paragraph({ size: "sm" }), "text-neutral-700")
const chevronDown = cn("h-6 w-6 shrink-0 transition-transform duration-200")
const accordionContent = (className?: string) =>
  cn(
    paragraph({ size: "sm" }),
    "text-neutral-700 overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down pt-1 pb-4 px-5",
    className,
  )

export {
  accordionContent,
  accordionHeader,
  accordionItem,
  accordionTrigger,
  accordionTriggerDescription,
  accordionTriggerTextContainer,
  chevronDown,
}
